<template>
    <div class="mb-0"  v-if="calculationData">
        <table class="table table-striped table-sm">    
            <thead>
                <tr>
                    <th style="width:40%">Projekt</th>
                    <th style="width:40%">Uppgift</th>
                    <th style="width:10%" class="text-right">Timmar</th>                
                    <th style="width:10%" class="text-right">Summa</th> 
                    <th>&nbsp;</th>                          
                </tr>
            </thead>   
            <tbody>
                <tr v-for="entry in calculationData.Chargeabilities" :key="entry.sum">
                    <td style="width:40%">{{entry.Project}}</td>
                    <td style="width:40%">{{entry.ProjectTask}}</td>
                    <td style="width:10%" class="text-right">{{entry.Hours}}</td>                 
                    <td style="width:10%" class="text-right">{{entry.Sum | currency}}</td>
                    <th>&nbsp;</th>                     
                </tr>       
            </tbody> 
            <tfoot>
                <tr>
                    <th colspan="2"><strong>Summa</strong></th>
                    <th class="text-right"><strong>{{calculationData.Hours}}</strong></th>         
                    <th class="text-right"><strong>{{calculationData.Sum | currency}}</strong></th>      
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
export default {
  props: {
    calculationData: null
  }
}
</script>

<style>

</style>
